import {
  EnhancedHeaderInputTypes,
  EnhancedTableHeader,
  EnhancedTableHeaderType
} from '@components/table/widgets/shared-with-old';

export const getAmendmentInsuredDetailsHeaders: (
  currency: string,
  disabled: boolean
) => Record<string, EnhancedTableHeader> = (
  currency: string,
  disabled: boolean
): Record<string, EnhancedTableHeader> => {
  // Default (non-group medical)
  const headers: Record<string, EnhancedTableHeader> = {
    insured: {
      name: 'insuredName',
      title: 'Insured Name',
      type: EnhancedTableHeaderType.Text,
      filterField: 'policyPerson.person.fullName'
    },
    relation: {
      name: 'relation',
      title: 'Relation',
      type: EnhancedTableHeaderType.Text,
      filterField: 'policyPerson.relation'
    },
    age: {
      name: 'age',
      title: 'Age',
      type: EnhancedTableHeaderType.Text,
      filterField: 'policyPerson.age'
    },
    cover: {
      name: 'cover',
      title: 'Cover',
      type: EnhancedTableHeaderType.Text,
      filterField: 'policyPlanCover.cover.code'
    },
    sumInsured: {
      name: 'sumInsured',
      title: 'Sum Insured',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currency,
      disableSort: true
    },
    netPremium: {
      name: 'netPremium',
      title: 'Net Premium',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currency,
      disableSort: true
    },
    netPremiumVariance: {
      name: 'netPremiumVariance',
      title: 'Net Premium Variance',
      type: EnhancedTableHeaderType.Input,
      inputType: EnhancedHeaderInputTypes.RoundedCurrency,
      currency: currency,
      allowNegative: true,
      maxValue: 0,
      disabled,
      disableSort: true
    },
    charges: {
      name: 'charges',
      title: 'Charges',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currency,
      disableSort: true
    },
    chargesVariance: {
      name: 'chargesVariance',
      title: 'Charges Variance',
      type: EnhancedTableHeaderType.Input,
      inputType: EnhancedHeaderInputTypes.RoundedCurrency,
      currency: currency,
      allowNegative: true,
      maxValue: 0,
      disabled,
      disableSort: true
    },
    tpaFees: {
      name: 'tpaFees',
      title: 'TPA Fees',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currency,
      disableSort: true
    },
    tpaFeesVariance: {
      name: 'tpaFeesVariance',
      title: 'TPA Fees Variance',
      type: EnhancedTableHeaderType.Input,
      inputType: EnhancedHeaderInputTypes.RoundedCurrency,
      currency: currency,
      allowNegative: true,
      maxValue: 0,
      disabled,
      disableSort: true
    },
    grossPremium: {
      name: 'grossPremium',
      title: 'Gross Premium',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currency,
      disableSort: true
    },
    grossPremiumVariance: {
      name: 'grossPremiumVariance',
      title: 'Gross Premium Variance',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currency,
      disableSort: true
    },
    totalPremium: {
      name: 'totalPremium',
      title: 'Total Premium',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currency,
      disableSort: true
    },
    totalPremiumVariance: {
      name: 'totalPremiumVariance',
      title: 'Total Premium Variance',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currency,
      disableSort: true
    }
  };

  return headers;
};
